<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bb-page clients-ticket-page"
  [class.rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bb-page-shell clients-ticket-shell">

    <!-- Header -->
    <header class="clients-mobile-hero">
      <div class="clients-hero-copy">
        <span class="bb-eyebrow">
          {{ "myclients" | transloco }}
        </span>

        <h2>
          {{ "myclients" | transloco }}
        </h2>

        <p>
          {{ "Manage your clients" | transloco }}
        </p>
      </div>

      <button
        type="button"
        class="clients-hero-action"
        (click)="goToCreateClient()"
        [attr.aria-label]="'create client' | transloco"
      >
        <i class="fa-solid fa-plus" aria-hidden="true"></i>
      </button>
    </header>

    <!-- Admin Warehouse Filter -->
    @if(isAdmin){
    <section class="clients-filter-card">
      <div class="clients-filter-title">
        <span>{{ "Pospage" | transloco }}</span>
        <small>{{ "Choose POS" | transloco }}</small>
      </div>

      <div class="dropdown w-100">
        <button
          class="bb-btn bb-btn-secondary clients-warehouse-select dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {{ selectedWarehouseName || ("Pospage" | transloco) }}
        </button>

        <ul class="bb-dropdown-menu dropdown-menu w-100">
          <li *ngFor="let el of allWareHouses">
            <button
              type="button"
              class="bb-dropdown-item dropdown-item"
              (click)="applyWareHouse(el.id, el.name)"
            >
              {{ el.name }}
            </button>
          </li>
        </ul>
      </div>
    </section>
    }

    <!-- Total Debit -->
    @if(isWarehouse){
    <section class="clients-debit-ticket">
      <div>
        <small>{{ "Total Outstanding Balance" | transloco }}</small>
        <strong>
          {{ totaldebit * -1 || 0 }}
          {{ "egpe" | transloco }}
        </strong>
      </div>

      <img src="/assets/accstet.png" [alt]="'debit' | transloco">
    </section>
    }

    <!-- Search -->
    <section class="clients-mobile-search">
      <div class="clients-search-label">
        <i class="fa-solid fa-phone" aria-hidden="true"></i>
        <span>{{ "Phone Number" | transloco }}</span>
      </div>

      <div class="clients-search-control">
        <input
          type="tel"
          inputmode="numeric"
          class="bb-input"
          [(ngModel)]="searchKey"
          (keyup.enter)="search()"
          placeholder="{{ 'Phone Number' | transloco }}"
        />

        <button
          *ngIf="!searching"
          type="button"
          class="bb-btn bb-btn-primary"
          (click)="search()"
        >
          <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
          {{ "search" | transloco }}
        </button>

        <button
          *ngIf="searching"
          type="button"
          class="bb-btn bb-btn-secondary"
          (click)="clearSearch()"
        >
          <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
          {{ "clear" | transloco }}
        </button>
      </div>
    </section>

    <!-- Clients -->
    <section class="clients-ticket-list">

      <article
        class="client-ticket"
        *ngFor="let element of allData; trackBy: trackByClient"
      >

        <!-- Top -->
        <div class="client-ticket-top">

          <div class="client-main-info">
            <div class="client-avatar">
              {{ element.client_name?.charAt(0) || '?' }}
            </div>

            <div class="client-copy">
              <span>
                {{ "client" | transloco }}
              </span>

              <h3>
                {{ element.client_name || '-' }}
              </h3>

              <p>
                <i class="fa-solid fa-phone" aria-hidden="true"></i>
                {{ element.phone_number || '-' }}
              </p>
            </div>
          </div>

          @if(isWarehouse){
          <button
            type="button"
            class="client-statement-btn"
            (click)="accStatement(element.phone_number)"
            [attr.aria-label]="'accountStatement' | transloco"
          >
            <img src="/assets/accstet.png" [alt]="'statement' | transloco">
          </button>
          }

        </div>

        <!-- Details -->
        <div class="client-ticket-details">

          <div class="client-detail-chip">
            <i class="fa-solid fa-phone" aria-hidden="true"></i>

            <span>
              {{ "Phone Number" | transloco }}
            </span>

            <strong>
              {{ element.phone_number || '-' }}
            </strong>
          </div>

          <div class="client-detail-chip">
            <i class="fa-solid fa-phone-volume" aria-hidden="true"></i>

            <span>
              {{ "Another Phone Number" | transloco }}
            </span>

            <strong>
              {{ element.another_phone || '-' }}
            </strong>
          </div>

          <div class="client-detail-chip client-detail-wide">
            <i class="fa-solid fa-location-dot" aria-hidden="true"></i>

            <span>
              {{ "address" | transloco }}
            </span>

            <strong>
              {{ element.address || '-' }}
            </strong>
          </div>

        </div>

        <!-- Actions -->
        <div class="client-actions-grid">

          <button
            type="button"
            class="client-action-btn"
            (click)="getClientOrders(element.orders)"
          >
            <img src="/assets/cart.png" [alt]="'orders' | transloco">
            <span>{{ "clientorders" | transloco }}</span>
          </button>

          <button
            type="button"
            class="client-action-btn"
            (click)="getClientproducts(element.stocks)"
          >
            <img src="/assets/quanity.png" [alt]="'products' | transloco">
            <span>{{ "clientproducts" | transloco }}</span>
          </button>

          @if(warehouseIsStore){
          <button
            type="button"
            class="client-action-btn client-action-success"
            (click)="addPet(element.id)"
          >
            <img src="/assets/addpet.png" [alt]="'add pet' | transloco">
            <span>{{ "add pet" | transloco }}</span>
          </button>
          }

          @if(isWarehouse){
          <button
            type="button"
            class="client-action-btn"
            (click)="accStatement(element.phone_number)"
          >
            <img src="/assets/accstet.png" [alt]="'statement' | transloco">
            <span>{{ "accountStatement" | transloco }}</span>
          </button>
          }

          <button
            type="button"
            class="client-action-btn client-action-warning"
            (click)="reOrder(element)"
          >
            <img src="/assets/reorder.png" [alt]="'reorder' | transloco">
            <span>{{ "add order" | transloco }}</span>
          </button>

          <button
            type="button"
            class="client-action-btn client-action-call"
            (click)="call(element.phone_number)"
          >
            <img src="/assets/call.png" [alt]="'call' | transloco">
            <span>{{ "call" | transloco }}</span>
          </button>

          <button
            type="button"
            class="client-action-btn client-action-whatsapp"
            (click)="chat(element.phone_number)"
          >
            <img src="/assets/chat.png" [alt]="'chat' | transloco">
            <span>{{ "chat" | transloco }}</span>
          </button>

        </div>

      </article>

    </section>

    <!-- No Data -->
    <div class="bb-empty-state bb-text-center" *ngIf="noData">
      <app-nodata></app-nodata>
    </div>

    <!-- See More -->
    <button
      type="button"
      class="bb-btn bb-btn-secondary clients-see-more-btn"
      *ngIf="hasMore && !contentReady"
      (click)="loadMore()"
    >
      {{ 'See More' | transloco }}
    </button>

  </div>
</section>

<!-- Shared Popup -->
<div
  *ngIf="showClientPopup"
  class="bb-modal-backdrop clients-popup-backdrop"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
  (click)="closeClientPopup()"
>
  <div
    class="bb-modal-card clients-popup-card"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >

    <div class="bb-modal-header">
      <h4>{{ popupTitle }}</h4>

      <button
        type="button"
        class="bb-modal-close"
        (click)="closeClientPopup()"
        [attr.aria-label]="'close' | transloco"
      >
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    </div>

    <div class="clients-popup-body">

      <!-- Orders Popup -->
      <ng-container *ngIf="popupType === 'orders'">

        <div
          *ngIf="selectedOrders.length > 0; else noOrdersBlock"
          class="clients-popup-list"
        >

          <div
            *ngFor="let order of selectedOrders"
            class="clients-popup-item order-card"
          >

            <div class="clients-popup-item-head">
              <div class="clients-popup-badge">
                #{{ order.id }}
              </div>

              <div class="clients-popup-status">
                <ng-container [ngSwitch]="order.order_status">
                  <span *ngSwitchCase="1">{{ "pending" | transloco }}</span>
                  <span *ngSwitchCase="2">{{ "approved" | transloco }}</span>
                  <span *ngSwitchCase="3">{{ "rejected" | transloco }}</span>
                  <span *ngSwitchCase="4">{{ "on the way" | transloco }}</span>
                  <span *ngSwitchCase="5">{{ "shipped" | transloco }}</span>
                  <span *ngSwitchCase="6">{{ "Deferred" | transloco }}</span>
                  <span *ngSwitchCase="7">{{ "notcontacttheclient" | transloco }}</span>
                  <span *ngSwitchCase="8">{{ "delivered" | transloco }}</span>
                </ng-container>
              </div>
            </div>

            <div class="order-products" *ngIf="order.item?.length">
              <div
                class="order-product-row"
                *ngFor="let productName of order.item; let i = index"
              >

                <div class="product-name">
                  <span class="product-icon">📦</span>
                  {{ productName }}
                </div>

                <div class="product-meta">
                  <span>
                    {{ 'Qty' | transloco }}:
                    {{ order.quantity?.[i] || 0 }}
                  </span>

                  <span>
                    {{ 'Price' | transloco }}:
                    {{ order.price?.[i] || 0 }}
                  </span>
                </div>

              </div>
            </div>

          </div>

        </div>

        <ng-template #noOrdersBlock>
          <div class="clients-empty-popup-state">
            <div class="empty-icon">📭</div>
            <p>{{ 'No orders yet' | transloco }}</p>
          </div>
        </ng-template>

      </ng-container>

      <!-- Products Popup -->
      <ng-container *ngIf="popupType === 'products'">

        <div
          *ngIf="selectedProducts.length > 0; else noProductsBlock"
          class="clients-popup-list"
        >

          <div
            *ngFor="let item of selectedProducts"
            class="clients-popup-item product-card"
          >
            <div class="product-main">
              <div class="product-title">
                <span class="product-icon">🛒</span>
                {{ isAr ? item.name_ar : (item.name_en || item.name_ar) }}
              </div>

              <div class="product-sub">
                {{ 'Type' | transloco }}:
                {{ getCategoryName(item.category_id) | transloco }}
              </div>
            </div>
          </div>

        </div>

        <ng-template #noProductsBlock>
          <div class="clients-empty-popup-state">
            <div class="empty-icon">📦</div>
            <p>{{ 'No products yet' | transloco }}</p>
          </div>
        </ng-template>

      </ng-container>

    </div>

    <div class="bb-modal-actions">
      <button
        type="button"
        class="bb-btn bb-btn-secondary"
        (click)="closeClientPopup()"
      >
        {{ "close" | transloco }}
      </button>
    </div>

  </div>
</div>